"use strict";

import Page from "./RevenueOnDate.jsx";

export const auth = true;
export const title = "i18n:dailyRevenue.pageTitle";
export const Component = Page;
